import React, { useEffect } from 'react';
import "./SingleProject2.css";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FaGithub } from 'react-icons/fa';

function Project2({ id, name, desc, tags, code, demo, image, theme, device }) {

  useEffect(() => {
    // Enregistrer le plugin ScrollTrigger de GSAP
    gsap.registerPlugin(ScrollTrigger);

    // Animation pour l'image (scale) sur chaque projet
    gsap.utils.toArray('.project').forEach((project) => {
      const img = project.querySelector('.project-img img');
      const info = project.querySelector('.project-info');
      const tags = project.querySelector('.tags');

      gsap.fromTo(
        img,
        {
          scale: 0.4,
          opacity: 0,
        },
        {
          scale: 1,  // devient normale
          opacity: 1, // devient visible
          duration: 1,

          scrollTrigger: {
            trigger: img,  // L'élément déclencheur est l'image elle-même
            start: 'top 100%',  // Déclenche l'animation quand l'élément entre dans la vue
            end: 'top 30%',
            scrub: 1, // Animation fluide
            ease: 'power1.inOut',
          }
        }
      );

      gsap.fromTo(
        [info],
        {
          opacity: 0,
          scale: 0.7,
          x: 0  // commence invisible
        },
        {
          opacity: 1,  // devient visible
          x: 0,
          duration: 1,
          scale: 1,
          scrollTrigger: {
            trigger: info,  // L'élément déclencheur est la div contenant la description et les tags
            start: 'top 80%',
            scrub: 1, // Animation fluide
            ease: 'power1.inOut',
            end: 'top 30%',
          }
        }
      );
      // gsap.utils.toArray('.project-tag').forEach((tag) => {
      //   gsap.fromTo(
      //     tag,
      //     {
      //       opacity: 0,
      //       scale: 0.5
      //     },
      //     {
      //       opacity: 1,
      //       scale: 1,
      //       duration: 0.5,
      //       stagger: 0.2, // Délai entre chaque animation
      //       scrollTrigger: {
      //         trigger: tag,
      //         start: 'top 80%',
      //         end: 'top 30%',
      //       }
      //     }
      //   );
      // });
    });
  }, []);

  return (
    <div className='project' style={{ marginTop: '50px' }}>
      <div className='project-img'>
        {/* <img style={device=='Mobile' && {objectFit: 'contain'}} src={image} alt={name} /> */}
        <img
          style={device === 'Mobile' ? { objectFit: 'contain' } : {}}
          src={image}
          alt={name}
        />

      </div>
      <div className='project-info'>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h1>{name}</h1>
          <a href={code} target='_blank' rel='noreferrer'>
            <FaGithub style={{ width: "40px", height: "40px", float: "right", position: "relative", right: "0", top: "10px", left: "30px", color: "black" }} />
          </a>
        </div>
        <p>{desc}</p>
        <div className='tags'>
          {tags.map(tag => (
            <span className='project-tag' key={tag}>{tag}</span>
          ))}
        </div>
      </div>

    </div>
  );
}

export default Project2;
